import Main from '../../pages/main-page/main-page';

function App(): JSX.Element {
  return (
    <Main/>
  );
}

export default App;
